// extracted by mini-css-extract-plugin
module.exports = {"dark":"logo-farm_dark__2NjFw","light":"logo-farm_light__p6ONT","lift":"logo-farm_lift__sjeO8"};